module.exports = __webpack_public_path__ + "img/store-logo.9c222276.png";